var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "el-drawer",
        {
          ref: "BjDrawerForm",
          staticClass: "drawer-data-form-20210720",
          attrs: { form: _vm.form, visible: _vm.visible, size: "680px" },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("BjDivider", [
                _vm._v(_vm._s(_vm.$t("CustomerFunction.steptitle"))),
              ]),
              _c(
                "div",
                { staticStyle: { height: "625px", "margin-left": "100px" } },
                [
                  _c(
                    "el-steps",
                    {
                      attrs: {
                        direction: "vertical",
                        active: _vm.active,
                        "finish-status": "success",
                        "process-status": "finish",
                      },
                    },
                    [
                      _c("el-step", {
                        attrs: {
                          title: _vm.$t("CustomerFunction.step1"),
                          description: _vm.$t("CustomerFunction.steps1"),
                        },
                      }),
                      _c("el-step", {
                        style:
                          _vm.active >= 1
                            ? "cursor: pointer;"
                            : "cursor: default;",
                        attrs: {
                          title: _vm.$t("CustomerFunction.step2"),
                          description: _vm.$t("CustomerFunction.steps2"),
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.openInside()
                          },
                        },
                      }),
                      _c("el-step", {
                        style:
                          _vm.active >= 2
                            ? "cursor: pointer;"
                            : "cursor: default;",
                        attrs: {
                          title: _vm.$t("CustomerFunction.step3"),
                          description: _vm.$t("CustomerFunction.steps3"),
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.openFinaForm()
                          },
                        },
                      }),
                      _c("el-step", {
                        style:
                          _vm.active >= 3
                            ? "cursor: pointer;"
                            : "cursor: default;",
                        attrs: {
                          title: _vm.$t("CustomerFunction.step4"),
                          description: _vm.$t("CustomerFunction.steps4"),
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.goUser()
                          },
                        },
                      }),
                      _c("el-step", {
                        style:
                          _vm.active >= 4
                            ? "cursor: pointer;"
                            : "cursor: default;",
                        attrs: {
                          title: _vm.$t("CustomerFunction.step5"),
                          description: _vm.$t("CustomerFunction.steps5"),
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.openFileUpload()
                          },
                        },
                      }),
                      _c("el-step", {
                        attrs: {
                          title: _vm.$t("CustomerFunction.step6"),
                          description: _vm.$t("CustomerFunction.steps6"),
                        },
                      }),
                      _c("el-step", {
                        attrs: {
                          title: _vm.$t("CustomerFunction.step7"),
                          description: _vm.$t("CustomerFunction.steps7"),
                        },
                      }),
                      _c("el-step", {
                        attrs: {
                          title: _vm.$t("CustomerFunction.step8"),
                          description: _vm.$t("CustomerFunction.steps8"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "footer",
                  staticStyle: { "margin-top": "50px" },
                },
                [
                  _vm.showButton
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { width: "200px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.handleConfirm },
                        },
                        [_vm._v(_vm._s(_vm.$t("okText")))]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("InsideDrawer", { ref: "InsideDrawer" }),
            ],
            1
          ),
        ]
      ),
      _c("FinanceForm", {
        ref: "FinanceForm",
        on: { financeReFresh: _vm.financeReFresh },
      }),
      _c("ChecklistFile", {
        ref: "ChecklistFile",
        on: { reFresh: _vm.reFresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }